import { select, call } from "redux-saga/effects";
import accessTokenSelector from "selectors/accessToken";
import network from "services/network";
import { AxiosResponse } from "axios";

function* getHeaders(): Generator<any> {
    const accessToken = yield select(accessTokenSelector);
    if (accessToken) {
        return {
            "x-parsley-access-token": accessToken,
        };
    } else {
        return {};
    }
}

export function* post<T>(
    url: string,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    data?: any
): Generator<unknown, T | null, AxiosResponse<T>> {
    const headers = yield getHeaders();
    const response = yield call(
        network.post,
        url,
        data && JSON.stringify(data),
        {
            headers,
        }
    );
    return response.data;
}
